export default {"src":"/uk/_next/static/media/pensionbeelogo-transparent.4448c956.svg","height":53,"width":160,"blurWidth":0,"blurHeight":0};